import React from 'react';
import InsyncModelWidgetRenderer from './InsyncModelWidgetRenderer';

const Preview: React.FC = () => <InsyncModelWidgetRenderer config={{}} />;

export default Preview;
